// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"2bbc58c6","3597":"ec2c2a80","3970":"49e2cde1","5347":"0b637252","8496":"b7884bca"}[chunkId] + ".chunk.css";
};